import { config } from '@/lib/env';

const OPENPANEL_ORGANISATION_URL = 'https://metrics.fast.onetrading.com/onetrading';

export const userConsolePath = (pid: string): string => `/operations/users/${pid}`;

/**
 * exchange-ui identifies OpenPanel profiles by the account holder's PID, so the profile may not exist
 * for users it never saw. Every non-production environment reports into the one non-prod project.
 */
export const openPanelProfileUrl = (pid: string, isNonProd: boolean = config.IS_NON_PROD): string =>
  `${OPENPANEL_ORGANISATION_URL}/${isNonProd ? 'one-trading-non-prod' : 'one-trading-production'}/profiles/${encodeURIComponent(pid)}`;

export const MM_PROGRAMS_ROUTE = '/operations/mm-programs';

export const mmProgramPath = (pid: string) => `${MM_PROGRAMS_ROUTE}/${encodeURIComponent(pid)}`;
